import { FC, PropsWithChildren } from 'react';

export const ModalBody: FC<PropsWithChildren<unknown>> = ({ children }) => (
  <div className="px-2 px-md-4 pb-md-4 py-4 py-xl-6 overflow-auto">{children}</div>
);
